export default class Gender {
    constructor(id, gender) {
        this.id = id;
        this.gender = gender;
    }
}